import { BtnPrimary } from '../Buttons/BtnPrimary';
import { BtnSecondary } from '../Buttons/BtnSecondary';
import Skeleton from 'react-loading-skeleton';
import { CircleAlert, CircleCheck, Clock3, LockKeyhole } from 'lucide-react';
import { useId } from 'react';
import styles from './style.module.css';

const PaymentStatus = ({
  complete,
  reference,
  cardStored,
  loading,
  error,
  sessionExpired,
  activeMethod,
  failedAttemptsByMethod,
  lockExpiries,
  initiateCheckoutSession,
  handleNewSession,
  handleStoredCardPayment,
  handleSwitchMethod,
  selectedStoredCard,
}) => {
  const titleId = useId();
  if (complete) {
    return (
      <div className={styles.errorCard} role="status" aria-labelledby={titleId}>
        <div className={styles.statusHeader}>
          <span className={`${styles.errorIcon} ${styles.successIcon}`}>
            <CircleCheck size={28} strokeWidth={1.75} aria-hidden="true" />
          </span>
          <div className={styles.statusContent}>
            <h3 id={titleId} className={styles.errorTitle}>Payment successful</h3>
            {reference && <p className={styles.errorMessage}>Reference: {reference}</p>}
            {cardStored && <p className={styles.errorMessage}>Card successfully saved.</p>}
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.loadingSkeletonWrap} aria-busy="true">
        <Skeleton height={20} width={260} style={{ marginBottom: 16 }} />
        <Skeleton height={48} count={3} style={{ marginBottom: 10 }} />
      </div>
    );
  }

  if (error) {
    const isLocked =
      activeMethod &&
      (failedAttemptsByMethod[activeMethod] || 0) >= 3 &&
      Date.now() < (lockExpiries[activeMethod] || 0);

    const title = sessionExpired
      ? "Session expired"
      : isLocked
      ? "Payment method locked"
      : "Payment unsuccessful";
    const StatusIcon = sessionExpired ? Clock3 : isLocked ? LockKeyhole : CircleAlert;

    return (
      <div className={styles.errorCard} role="alert" aria-labelledby={titleId}>
        <div className={styles.statusHeader}>
          <span className={styles.errorIcon} data-state={sessionExpired || isLocked ? 'session' : 'error'}>
            <StatusIcon size={28} strokeWidth={1.75} aria-hidden="true" />
          </span>
          <div className={styles.statusContent}>
            <h3 id={titleId} className={styles.errorTitle}>{title}</h3>
            <p className={styles.errorMessage}>{error}</p>
            {sessionExpired && (
              <p className={styles.errorHint}>Return to billing details to start a new payment session.</p>
            )}
          </div>
        </div>
        <div className={styles.errorActions}>
          {sessionExpired ? (
            <BtnPrimary label="Back to Billing Details" handleClick={handleNewSession} noIcon />
          ) : (
            <>
              <BtnPrimary
                label="Try Again"
                handleClick={initiateCheckoutSession}
                disabled={isLocked}
                nativeDisabled
                noIcon
              />
              <BtnSecondary
                label="Switch Payment Method"
                handleClick={handleSwitchMethod}
              />
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default PaymentStatus;
